<div class="content-card-jumbotron">
    <div *ngIf="icon" class="card-jumbotron-icon">
        <kui-icon [name]="icon"></kui-icon>
    </div>
    
    <div class="card-jumbotron-text">
        <ng-content></ng-content>
    </div>
</div>